import { toValue } from 'vue';

import {
    defaultPrivacyPolicyUrlKey,
    defaultTosUrlKey,
    upcomingTosUrlKey,
} from '@utils/consts';

export interface LegalUrls {
    tos: string;
    privacyPolicy: string;
}

export interface UseLegaUrlReturn {
    links: ComputedRef<LegalUrls>;
    upcomingTosUrl: ComputedRef<LegalUrls['tos']>;
    currentTosUrl: ComputedRef<LegalUrls['tos']>;
}

export const useLegalUrl = (
    tosSwitchDate = new Date('2025-12-01T00:00:00Z')
): UseLegaUrlReturn => {
    const { t } = useI18n();

    const isUpcomingTosVersion = Date.now() >= tosSwitchDate.getTime();

    const upcomingTosUrl = computed(() => t(upcomingTosUrlKey));
    const currentTosUrl = computed(() => t(defaultTosUrlKey));

    const links = computed(() => ({
        tos: toValue(isUpcomingTosVersion ? upcomingTosUrl : currentTosUrl),
        privacyPolicy: t(defaultPrivacyPolicyUrlKey),
    }));

    return {
        links,
        upcomingTosUrl,
        currentTosUrl,
    };
};
